import React from 'react'
import { ACCOUNT_STATUS } from 'common/constants'
import { useEffect, useSelector, useLocation } from 'hooks'

const OfferPopupContainer = () => {
  const { pathname } = useLocation()
  const isActivated = useSelector(s => s.myProfile?.accountStatus == ACCOUNT_STATUS.ACTIVATED)
  const ready = !!window.$?.DF && isActivated

  useEffect(() => {
    ready && window.$.DF.Offer.init({ niche: 'adult-react', premium: false })
  }, [ready])

  useEffect(() => {
    ready && window.$.DF.Offer.onLocationChange()
  }, [pathname])

  return <div id="offer-popup-container" />
}

export default OfferPopupContainer
